import { BaseEntity } from 'yt-ng-framework';

export class ZbirniDnevnikView extends BaseEntity {
    constructor(){
        super();
    }

    Datum: Date = null;
    Ulaz: number = null;
    Izlaz: number = null;
    Razlika: number = null;


    Deserialize(input: any){
        this.ID = input.ID;
        this.Datum = input.Datum;
        this.Ulaz = input.Ulaz;
        this.Izlaz = input.Izlaz;
        this.Razlika = input.Razlika;
    
        return this;
    }

    Serialize(input: ZbirniDnevnikView){
        return input;
    }
}
